import React from 'react';
import { useRouteError } from 'react-router-dom';
import { recordZ4RumError } from '@marageti/z4-lib';
import DefaultError from './DefaultError';
// React Router Dom recommends to replace the default error element to be returned.
// https://reactrouter.com/en/main/route/error-element#default-error-element
const ErrorBoundaryRouter = () => {
  const error = useRouteError();

  if (error instanceof Error) {
    recordZ4RumError(error, { componentStack: error.stack });
  } else if (error) {
    recordZ4RumError(new Error(String(error)));
  }

  return <DefaultError />;
};

export default ErrorBoundaryRouter;
